import type { GeoLocation } from '../../../types/core';
import type { ApplicantQualification } from '../../../types/rest-api';

/** Persists profile wizard data (sessionStorage). */
export const PROFILE_WIZARD_DRAFT_KEY = 'bn_profile_wizard_draft_v1';

export interface ProfileWizardDraft {
  personalForm: Record<string, any>;
  personalLocation?: GeoLocation;
  employmentTypeForm: Record<string, any>;
  selectedJobFunctions: {
    value: string;
    jobLevels: string[];
    jobLevelDescriptions: string[];
    /** null = not answered yet. */
    inStudy: boolean | null;
    /** null = not answered; missing in drafts saved before the question. */
    isQualified?: boolean | null;
    /** The level; missing in drafts saved before the four levels. */
    qualification?: ApplicantQualification | null;
  }[];
  avatarBase64?: string;
  currentStepIndex: number;
}

export function saveProfileWizardDraft(draft: ProfileWizardDraft): void {
  sessionStorage.setItem(PROFILE_WIZARD_DRAFT_KEY, JSON.stringify(draft));
}

export function loadProfileWizardDraft(): ProfileWizardDraft | null {
  try {
    const raw = sessionStorage.getItem(PROFILE_WIZARD_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ProfileWizardDraft;
  } catch {
    return null;
  }
}

export function clearProfileWizardDraft(): void {
  sessionStorage.removeItem(PROFILE_WIZARD_DRAFT_KEY);
}
